/* eslint-disable no-empty */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState, useContext, useCallback, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { SubmittedContext } from 'SubmittedContext';
import { CountryContext } from 'CountryContext';
import { getPhoneNumberLength } from 'common/utils';
import { Modal } from 'components/Modal';
import { StatusModal } from 'components/Modal/StatusModal';
import { PERSONAS, BASE_URL } from 'common/constants';
import 'components/Modal/index.scss';

export const WishListForm = ({ visible, onClose, phone, type }) => {
  const { country } = useContext(CountryContext);
  const { setSubmitted } = useContext(SubmittedContext);
  const [statusData, setStatusData] = useState(null);

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [consent, setConsent] = useState(true);
  const [phoneNumber, setNumber] = useState(phone);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setNumber(phone);
  }, [phone]);

  const onChangeName = useCallback((event) => {
    const { value } = event.target;
    setName(value);
  }, []);

  const onChangeEmail = useCallback((event) => {
    const { value } = event.target;
    setEmail(value);
  }, []);

  const onChangeCity = useCallback((event) => {
    const { value } = event.target;
    setCity(value);
  }, []);

  const onChangePhone = useCallback((event) => {
    const { value } = event.target;
    setNumber(value);
  }, []);

  const onChangeConsent = useCallback(() => {
    setConsent((prev) => !prev);
  }, []);

  const onSubmitTeen = async (params) => {
    setLoading(true);
    try {
      const stream = await fetch(`${BASE_URL}/submit/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Request-Headers': '*',
        },
        body: JSON.stringify({
          ...params,
          instagram: '',
          url: '',
        }),
      });
      const response = await stream.json();
      setStatusData({
        name: response.given_name,
        link: response.social_url,
        position: response.contest_score_rank,
        refsMade: response.referrals,
      });
      setSubmitted(true);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const onSubmitParent = async (params) => {
    setLoading(true);
    try {
      const stream = await fetch(`${BASE_URL}/submit/parent/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Request-Headers': '*',
        },
        body: JSON.stringify({ ...params, linkedin: '' }),
      });
      const response = await stream.json();
      setStatusData({
        name: response.first_name,
        link: response.social_url,
        position: response.contest_score_rank,
        refsMade: response.referrals,
      });
      setSubmitted(true);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    const params = {
      name,
      email,
      city,
      consent,
      phone: phoneNumber,
      region: country.toUpperCase(),
    };

    if (type === PERSONAS.PARENT) {
      await onSubmitParent(params);
      return;
    }

    await onSubmitTeen(params);
  };

  return (
    <Modal visible={visible} onClose={onClose}>
      {statusData ? (
        <StatusModal type={type} {...statusData} />
      ) : (
        <Row>
          <Col className="text-center">
            <p className="form__title mb-4">Get Access</p>
            <p className="form__subtitle mb-4">
              Yodaa is invite only.
              <br />
              Sign up now to get early access!
            </p>
            <form onSubmit={onSubmit}>
              <input
                placeholder="Name"
                title="Enter a valid name"
                type="text"
                required
                maxLength={32}
                value={name}
                onChange={onChangeName}
                className="modal-form__input my-3"
              />
              <input
                placeholder="Email"
                title="Enter a valid email"
                type="email"
                required
                value={email}
                onChange={onChangeEmail}
                className="modal-form__input my-3"
              />
              <input
                placeholder="City"
                title="Enter a valid city"
                type="text"
                required
                value={city}
                onChange={onChangeCity}
                className="modal-form__input my-3"
              />
              <input
                type="tel"
                required
                pattern="^[0-9]+$"
                minLength={getPhoneNumberLength(country)}
                maxLength={getPhoneNumberLength(country)}
                placeholder="Phone Number"
                title="Enter a valid phone number"
                value={phoneNumber}
                onChange={onChangePhone}
                className="modal-form__input my-3"
              />
              <label htmlFor="consent" className="modal-form__label mt-3">
                <input
                  id="consent"
                  type="checkbox"
                  style={{ verticalAlign: 'middle' }}
                  checked={consent}
                  className="mr-2"
                  onChange={onChangeConsent}
                />
                I consent to Yodaa.Club sending me updates on WhatsApp and Email
              </label>
              <Row className="justify-content-center">
                <input
                  type="submit"
                  value={loading ? 'Please Wait' : 'Request Access'}
                  className="modal-form__submit mt-3"
                />
              </Row>
            </form>
          </Col>
        </Row>
      )}
    </Modal>
  );
};
